import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { WebsitePrimaryButton } from '@dev/ee-components';
import { LockIcon } from '@/services/icons/LockedIcon';
import { BodyWrapper, TitleLockIcon, TitleWrapper, UpsellingInfoWrapper } from './styles';
import { UpsellingInfoProps } from './types';

export const RecaptchaLockedInfo = (props: UpsellingInfoProps): JSX.Element => {
    const { t } = useTranslation();
    const {
        title = { text: t('googlerecaptcha'), icon: <LockIcon width={15} height={15} /> },
        body = { subtitle: t('googlerecaptchalockedsubtitle'), text: t('googlerecaptchalockedbody') },
        button = { startIcon: <LockIcon width={20} height={20} />, text: t('upgradetounlock') },
        isSidebar = true,
    } = props;

    return (
        <UpsellingInfoWrapper $isSidebar={isSidebar}>
            <TitleWrapper $isSidebar={isSidebar}>
                {title?.icon && <TitleLockIcon>{title?.icon}</TitleLockIcon>}
                <Typography variant="h2" style={{ fontWeight: 'bold' }}>
                    {title?.text}
                </Typography>
            </TitleWrapper>
            <BodyWrapper $isSidebar={isSidebar}>
                {body?.subtitle && <Typography variant="h3">{body?.subtitle}</Typography>}
                <Typography variant="body1">{body.text}</Typography>
            </BodyWrapper>
            <WebsitePrimaryButton
                text={button?.text}
                startIcon={button?.startIcon}
                style={{ maxWidth: '175px' }}
                onClick={button?.onClick}
            />
        </UpsellingInfoWrapper>
    );
};
